"use client";

import FB from "@/assets/fb.png";
import IG from "@/assets/ig.png";
import X from "@/assets/x.png";
import { FaLinkedin, FaYoutube } from "react-icons/fa";
import Image from "next/image";
import Link from "next/link";
import { useLocale, useTranslations } from "@/i18n/provider";
import { isExternalHref, localizePath } from "@/i18n/pathnames";

// [
//       { name: "Travel & Adventure", href: "/explore/search?query=travel" },
//       { name: "Fitness & Sports", href: "/explore/search?query=fitness" },
//       { name: "Creative & Arts", href: "/explore/search?query=creative" },
//       { name: "Health & Wellness", href: "/explore/search?query=health" },
//       { name: "Lifestyle", href: "/explore/search?query=lifestyle" },
//       { name: "Tech", href: "/explore/search?query=tech" },
//     ],

export const Footer = () => {
  const t = useTranslations();
  const locale = useLocale();
  const year = new Date().getFullYear();
  const footerLinks = [
    {
      title: t("footer.explore"),
      links: [
        { name: t("footer.travel"), href: "/explore/category/travel" },
        { name: t("footer.fitness"), href: "/explore/category/fitness" },
        { name: t("footer.creative"), href: "/explore/category/creative" },
        { name: t("footer.health"), href: "/explore/category/health" },
        { name: t("footer.lifestyle"), href: "/explore/category/lifestyle" },
        { name: t("footer.tech"), href: "/explore/category/tech" },
      ],
    },
    {
      title: t("footer.activities"),
      links: [
        { name: t("footer.allActivities"), href: "/explore" },
        { name: t("footer.activeActivities"), href: "/explore/type/active" },
        { name: t("footer.guidedActivities"), href: "/explore/type/guided" },
        {
          name: t("footer.upcomingActivities"),
          href: "/explore/type/upcoming",
        },
      ],
    },
    {
      title: t("footer.resources"),
      links: [{ name: t("footer.blog"), href: "https://blog.cliqbox.co" }],
    },
    {
      title: t("footer.grow"),
      links: [
        { name: t("common.becomePartner"), href: "/partner" },
        { name: t("common.becomeCreator"), href: "/creator" },
      ],
    },
    {
      title: t("footer.company"),
      links: [
        { name: "hello@cliqbox.co", href: "mailto:hello@cliqbox.co" },
        { name: t("footer.terms"), href: "https://termsos.cliqbox.co" },
        { name: t("footer.privacy"), href: "https://privacy.cliqbox.co" },
        { name: t("footer.cookie"), href: "https://cookies.cliqbox.co" },
      ],
    },
  ];

  return (
    <footer className="bg-[#0A0D14] text-white">
      <div className="container lg:!px-0 flex flex-col gap-3 items-center  justify-between pb-10 pt-20">
        <div className="w-full mx-auto grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 mb-10">
          {footerLinks.map((section) => (
            <div key={section.title} className="space-y-4">
              <h3 className="text-sm font-semibold text-gray-900">
                {section.title}
              </h3>
              <ul className="space-y-2">
                {section.links.map((link) => (
                  <li key={link.name}>
                    <Link
                      href={
                        isExternalHref(link.href)
                          ? link.href
                          : localizePath(link.href, locale)
                      }
                      target={isExternalHref(link.href) ? "_blank" : undefined}
                      rel={
                        isExternalHref(link.href)
                          ? "noopener noreferrer"
                          : undefined
                      }
                      className="text-sm text-[#E1E4EA] hover:text-white"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <hr className="border-[0.1px] border-[#868C98] w-full " />

        <div className="w-full flex flex-col gap-5 md:gap-0 md:flex-row md:justify-between justify-center">
          <div className="flex justify-center">
            <p className="text-xs pt-3">{t("common.copyright", { year })}</p>
          </div>

          <div className="flex items-center justify-center md:justify-start gap-2">
            <a
              href="https://twitter.com/cliqboxhq"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Image src={X.src} alt="X" width={20} height={20} />
            </a>
            <a
              href="https://facebook.com/ajobox"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Image src={FB.src} alt="Facebook" width={20} height={20} />
            </a>
            <a
              href="https://instagram.com/cliqboxhq"
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              <Image src={IG.src} alt="Instagram" width={20} height={20} />
            </a>

            <a
              href="https://linkedin.com/company/cliqboxhq"
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              <FaLinkedin size={19} />
            </a>

            <a
              href="https://youtube.com/cliqboxhq"
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              <FaYoutube size={19} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
